import { Community, BicycleRoute, RouteCommunity, ProjectCommunity, BMNCity } from '@/interfaces';
export default class DataService {

  public getCommunitiesForRoute(route: BicycleRoute, communities: Community[], rc: RouteCommunity[]): Community[] {
    const filteredRc: RouteCommunity[] = rc.filter(r => {
      return route.id === r.routeId;
    });
    const communitiesToReturn: Community[] = [];

    filteredRc.forEach((frc: RouteCommunity, index: number) => {
      communitiesToReturn[index] = communities.find(comm => {
        return comm.id === frc.communityId;
      });
    });

    return communitiesToReturn;
  }

  public getCommunitiesForProject(data: {id: string}, communities: Community[], pc: ProjectCommunity[]): Community[] {
    let filteredPc: ProjectCommunity[];
    if (data.id.startsWith('mirt')) {
      filteredPc = pc.filter(p => {
        return data.id.split('-')[0] === p.projectId;
      });
    } else {
      filteredPc = pc.filter(p => {
        return data.id === p.projectId;
      });
    }
    const communitiesToReturn: Community[] = [];

    filteredPc.forEach((fpc: ProjectCommunity, index: number) => {
      communitiesToReturn[index] = communities.find(comm => {
        return comm.id === fpc.communityId;
      });
    });

    return communitiesToReturn;
  }

  public getCompaniesByCommunities(communities: Community[]): number {
    let comps: number = 0;
    communities.forEach(com => {
      if (com.numberOfCompanies) {
        comps += com.numberOfCompanies;
      }
    });
    return comps;
  }

  public getCommunityNames(communities: Community[]): string[] {
    if (!communities) {
      return;
    }
    const communityNames = [];
    communities.forEach(comm => {
      communityNames.push(comm.name);
    });
    return communityNames;
  }

  public getCommunityById(id: string, communities: Community[]): Community {
    id = id.replace('src', 'com');
    return communities.find(comm => {
      return comm.id === id;
    });
  }

  public getDataType(data: any) {
    switch (data.id.split('-')[0]) {
      case 'com':
        return 'community';
      case 'bereikbaarheidsakkoord':
        return 'project';
      case 'mirt':
        return 'project';
      case 'route':
        return 'snelfietsroute';
      default:
        return '';
    }
  }
}
